
/**
 * @param {?} value
 * @return {?}
 */
export function removeDelimiter(value: string): number {
  const /** @type {?} */ isDot = /[d\.]/g;

  const /** @type {?} */ removedDelimiter = value.replace(isDot, '');
  let /** @type {?} */ number = parseInt(removedDelimiter);

  if (value === '') {
    number = null;
  }

  return number;
}
